export default __webpack_public_path__ + "static/media/5.7d932011.png";